//import { Counter } from "./components/Counter";
//import { FetchData } from "./components/FetchData";
import Home from "./components/Home";
import ReconcilePage from "./components/stats/reconcile/ReconcilePage";
import ResultsPage from "./components/stats/ResultsPage";
import ConfigurationManager from "./ConfigurationManager";


const AppRoutes = [
  {
    index: true,
    path: '/',
    element: <Home />
    ,isPrivate: true
  },
  {
    path: '/reconcile',
    element: (
      <ReconcilePage
        caption="Riconciliazione fatture elettroniche ricevute"
        users={[ConfigurationManager.users.barbara]}
        roles={[ConfigurationManager.userRoles.administrators]} 
      />
    ),
    isPrivate: true
  },
  {
    path: '/results',
    element: <ResultsPage />,
    isPrivate: true
  }
  //{
  //  path: '/counter',
  //  element: <Counter />
  //},
  //{
  //  path: '/fetch-data',
  //  element: <FetchData />
  //}
];

export default AppRoutes;
